import { render, staticRenderFns } from "./GalleryDetailComponent.vue?vue&type=template&id=b00cf818&scoped=true&"
import script from "./GalleryDetailComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00cf818",
  null
  
)

export default component.exports